export const PAID_MESSAGE = 'This Breach Notice has been paid. Thank you!';

export const DR_PAID_IN_FULL_MESSAGE =
  'This breach notice was previously referred to Debt Recovery (Baycorp) but has now been paid in full. Thank you.';

export const DR_PAID_SETTLEMENT_MESSAGE =
  'This breach notice was previously referred to Debt Recovery (Baycorp) but has now been paid. Thank you.';

export const WITH_DR_MESSAGE =
  'This breach notice has been lodged for Debt Recovery (Baycorp).';

export const DR_CANCELLED_MESSAGE =
  'This breach notice was previously referred to Debt Recovery (Baycorp), but the recovery process has been cancelled.';
